import { Link } from 'react-router-dom';
import { rankingComics } from '@/mocks/comics';

export default function Ranking() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            人气排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全站最受欢迎漫画 TOP 10</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {rankingComics.map((comic, idx) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-4 p-4 bg-white rounded-xl hover:bg-background-50 transition-colors cursor-pointer group border border-background-200/50"
          >
            <div className={`w-8 h-8 flex-shrink-0 rounded-lg flex items-center justify-center text-sm font-bold ${
              idx < 3 ? 'bg-accent-500 text-white' : 'bg-secondary-100 text-secondary-600'
            }`}>
              {idx + 1}
            </div>
            <div className="w-14 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
              <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{comic.title}</h3>
              <div className="flex items-center gap-3 mt-1">
                <span className="text-xs text-accent-500 font-medium whitespace-nowrap">
                  <i className="ri-star-fill w-3 h-3 inline-flex items-center justify-center"></i> {comic.rating}
                </span>
                <span className="text-xs text-foreground-400">{comic.views}</span>
              </div>
            </div>
            <div>
              <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
                comic.status === '连载中' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}